import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-windowView",
  "use": "icon-windowView-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-windowView\"><defs><clipPath id=\"icon-windowView_a\"><path data-name=\"矩形 98\" d=\"M0 0h18v18H0z\" /></clipPath></defs><g clip-path=\"url(#icon-windowView_a)\"><path d=\"M9.001 3.324a9.973 9.973 0 0 0-9 5.673 9.975 9.975 0 0 0 18 0 9.973 9.973 0 0 0-9-5.673zm0 8.87a3.033 3.033 0 1 1 3.037-3.029 3.033 3.033 0 0 1-3.037 3.032z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol